import { totalRecordByProjectConstants } from "../constant/totalRecord.constants";

export const initialState = {
    dataTotalRecordByProject: [],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const totalRecordByProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case totalRecordByProjectConstants.GET_SUCCESS:
            return {
                ...state,
                dataTotalRecordByProject: action.totalRecordByProjectList,
                isLoading: true
            };
        case totalRecordByProjectConstants.GET_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        default:
            return state;
    }
};

export default totalRecordByProjectReducer;
